'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const Moment = require('moment');
const find = require('lodash/find');
const filter = require('lodash/filter');

const Globals = require('../../../../app/globals');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import SortableTableClassic from '../table/SortableTableClassic';
import AdminUserInfoBlock from './AdminUserInfoBlock';
import ConfirmModal from '../modal/ConfirmModal';
import PaginationControls from '../table/PaginationControls';

const USER_AUTHORS = 'authors';
const USER_LTI = 'ltiUsers';
const USER_ALL = 'USER_ALL'; //TODO

const propTypes = {};
const defaultProps = {};

class AdminUsersView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userStoreState: AdminGlobalUserStore.getState(),
            selectedUser: null,
            getAuthorsActionId: null,
            getLTIUsersActionId: null,
            getChannelRolesActionId: null,
            viewUserType: USER_AUTHORS,
            deleteActionId: null,
            deleteUserModalVisible: false,
            userIdToDelete: null,
            filter: '',
            filterApplied: '',
            sortBy: '',
            sortOrder: '',
        };

        this.onUserClick = this.onUserClick.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.changeUserType = this.changeUserType.bind(this);
        this.toggleDeleteUserModal = this.toggleDeleteUserModal.bind(this);
        this.onDeleteUser = this.onDeleteUser.bind(this);
        this.requestUserPage = this.requestUserPage.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.doApplyFilter = this.doApplyFilter.bind(this);
        this.unsubscribes = [
            AdminGlobalUserStore.listen(this.onStoreChange.bind(this, 'userStoreState'))
        ];
    }

    componentDidMount() {
        if (!this.state.userStoreState.initializedAuthors) {
            GlobalUserActions.getAuthors(uuid.v4()); // get page 1
        }

        if (!this.state.userStoreState.initializedLtiUsers) {
            GlobalUserActions.getLTIUsers(uuid.v4()); // get page 1
        }

        SubscriptionPlanActions.getPlans(uuid.v4()); //TODO put this in AdminUserPlanSelctor component (needs to happen only once)
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, state) {
        var changes = { [storeStateName]: state };
        if ((storeStateName === 'userStoreState') && (this.state.selectedUser)) {
            var userId = this.state.selectedUser.id;
            changes.selectedUserChannelRoles = this.state.userStoreState.userChannelRoles[userId];
        }

        if (state.action.id === this.state.deleteActionId) {
            changes.deleteActionId = null;
        }

        if (!!this.state.selectedUser) { // refresh selected user data
            changes = { ...changes, ...this._getSelectedUserDataById(this.state.selectedUser.id, this.state.viewUserType, state) };
        }

        this.setState(changes);
    }

    _getSelectedUserDataById(userId, viewUserType, userStoreState) {
        let users;
        if (viewUserType == USER_AUTHORS) {
            users = userStoreState['authors'];
        }
        else if (viewUserType == USER_LTI) {
            users = userStoreState['ltiUsers'];
        }
        else {
            console.error('Invalid view type:', viewUserType);
            return null;
        }

        const user = find(users, { id: userId });
        let selectedUserChannelRoles = userStoreState.userChannelRoles[userId];
        if (typeof selectedUserChannelRoles === 'undefined') {
            selectedUserChannelRoles = {
                channel_roles: [],
                pending: true,
            };
            const actionId = uuid.v4();
            GlobalUserActions.getChannelRoles(actionId, userId);
        }

        return {
            selectedUser: user,
            selectedUserChannelRoles: selectedUserChannelRoles,
        };
    }

    onUserClick(e, userId) {
        const selectedUserDataObj = this._getSelectedUserDataById(userId, this.state.viewUserType, this.state.userStoreState);
        this.setState(selectedUserDataObj);
    }
    
    onSortChange(sortKey,asc) {
        this.setState({
            sortBy: sortKey,
            sortOrder: asc ? 'asc' : 'desc',
        },()=>{
            this.requestUserPage(this.state.viewUserType);
        });
    }

    toggleDeleteUserModal(visible, userIdToDelete) {
        this.setState({ deleteUserModalVisible: visible, userIdToDelete: userIdToDelete || null });
    }

    onDeleteUser() {
        const actionId = uuid.v4();
        const userIdToDelete = this.state.userIdToDelete;

        this.setState(
            {
                userIdToDelete: null,
                deleteUserModalVisible: false,
                deleteActionId: actionId,
                selectedUser: this.state.selectedUser.id === userIdToDelete ? null : this.state.selectedUser,

            }, () => {
                GlobalUserActions.deleteUser(actionId, userIdToDelete);
            }
        );
    }

    changeUserType(type) {
        this.setState({
            viewUserType: type,
            selectedUser: null,
            filter: '',
            filterApplied: '',
        });
    }

    requestUserPage(type, page) {
        if (type === USER_AUTHORS) {
            GlobalUserActions.getAuthors(
                uuid.v4(),
                {
                    userPage: page,
                    userSearch: this.state.filter,
                    userSort: this.state.sortBy,
                    userSortOrder: this.state.sortOrder,
                }
            );
        }
        else if (type === USER_LTI) {
            GlobalUserActions.getLTIUsers(
                uuid.v4(),
                {
                    userPage: page,
                    userSearch: this.state.filter,
                    userSort: this.state.sortBy,
                    userSortOrder: this.state.sortOrder,
                }
            );
        }
    }

    onFilterChange(value) {
        this.setState({ filter: value });
    }

    doApplyFilter() {
        this.setState({ filterApplied: typeof this.state.filter === 'string' ? this.state.filter.trim() : this.state.filter });
    }

    render() {
        if (!this.state.userStoreState.initialized) {
            return <LoadingMainContent/>;
        }

        let users;
        let currentPage;
        let numPages;
        let filterPages;
        let totalRecords;
        let searchTerm;
        let requestPage;
        let matchesFilterApplied;



        if (this.state.viewUserType == USER_AUTHORS) {
            users = this.state.userStoreState['authors'];
            currentPage = this.state.userStoreState.userPagination['authors'].currentPage;
            numPages = this.state.userStoreState.userPagination['authors'].numPages;
            filterPages = this.state.userStoreState.userPagination['authors'].filterPages
            totalRecords = this.state.userStoreState.userPagination['authors'].totalRecords;
            searchTerm = this.state.userStoreState.userPagination['authors'].searchTerm;
            requestPage = this.requestUserPage.bind(this, USER_AUTHORS);
            matchesFilterApplied = (userObj, filterTerm) => {
                if (!filterTerm) return true;
                const filterTermToLower = filterTerm.toLowerCase();
                return (
                     (!!userObj.email && userObj.email.toLowerCase().indexOf(filterTermToLower)) >= 0
                    ||  (!!userObj.first_name && userObj.first_name.toLowerCase().indexOf(filterTermToLower)) >= 0
                    ||  (!!userObj.last_name && userObj.last_name.toLowerCase().indexOf(filterTermToLower)) >= 0
                    ||  (!!userObj.display_name && userObj.display_name.toLowerCase().indexOf(filterTermToLower)) >= 0
                );
            }
        }
        else if (this.state.viewUserType == USER_LTI) {
            users = this.state.userStoreState['ltiUsers'];
            currentPage = this.state.userStoreState.userPagination['ltiUsers'].currentPage;
            numPages = this.state.userStoreState.userPagination['ltiUsers'].numPages;
            filterPages = this.state.userStoreState.userPagination['ltiUsers'].filterPages
            totalRecords = this.state.userStoreState.userPagination['ltiUsers'].totalRecords;
            searchTerm = this.state.userStoreState.userPagination['ltiUsers'].searchTerm;
            requestPage = this.requestUserPage.bind(this, USER_LTI);
            matchesFilterApplied = (userObj, filterTerm) => {
                if (!filterTerm) return true;
                const filterTermToLower = filterTerm.toLowerCase();
                return (
                    (!!userObj.third_party_id && userObj.third_party_id.toLowerCase().indexOf(filterTermToLower)) >= 0
                    || (!!userObj.third_party_email && userObj.third_party_email.toLowerCase().indexOf(filterTermToLower)) >= 0
                    || (!!userObj.last_name && userObj.last_name.toLowerCase().indexOf(filterTermToLower)) >= 0
                    || (!!userObj.first_name && userObj.first_name.toLowerCase().indexOf(filterTermToLower)) >= 0
                );
            }
        }
        else {
            console.error('Invalid view type:', this.state.viewUserType);
            return null;
        }

        // Filter out non matching records for applied filter
        // For record sets of less than onepage of results only. Otherwise server search is called by PaginationControl
        if (this.state.filterApplied) {
            users = filter(users, (user) => {
                return matchesFilterApplied(user, this.state.filterApplied);
            });
        }

        // set account_status based on subscription_data
        users.forEach((user) => {
            user.account_status = ''; // default
            if ([Globals.users.account_types.FREE, Globals.users.account_types.FREE_V2].indexOf(user.account_type) === -1 ) {
                var sd = user.subscription_data;
                if (sd) {
                    user.account_status = sd.subscription_status;
                    if (sd.subscription_status === Globals.ecommerce.subscription_statuses.active) {
                        if (sd.subscription_ending_at) {
                            const now = Moment(new Date());
                            const end_date = Moment(sd.subscription_ending_at);
                            if (end_date.isBefore(now)) {
                                user.account_status = 'end ' + end_date.format('YYYY-MM-DD');
                            }
                        }
                    }
                }
            }

            user.banned = find(user.ban_history, { active: true }) ? 'BANNED' : '';
        });

        const columnsForUserType = {
            [USER_AUTHORS]: [
                {
                    displayName: 'ID',
                    key:'id',
                    size: 1,
                    type: 'int',
                    width: '5%'
                },
                {
                    displayName: 'First Name',
                    key:'first_name',
                    size: 2,
                    type: 'string',
                    width: '10%'
                },
                {
                    displayName: 'Last Name',
                    key:'last_name',
                    size: 2,
                    type: 'string',
                    width: '10%'
                },
                {
                    displayName: 'Email',
                    key: 'email',
                    size: 3,
                    type: 'string',
                    width: '25%'
                },
                {
                    displayName: 'Created Date',
                    key:'created_at',
                    size: 3,
                    type: 'date',
                    width: '12.5%'
                },
                {
                    displayName: 'Last Active',
                    key:'active_at',
                    size: 3,
                    type: 'date',
                    width: '12.5%'
                },
                {
                    displayName: 'Admin',
                    key:'admin',
                    size: 1,
                    type: 'bool',
                    width: '5%'
                },
                {
                    displayName: 'Acc. Type',
                    key: 'account_type',
                    size: 2,
                    type: 'string',
                    width: '10%'
                },
                {
                    displayName: 'Acc. Status',
                    key: 'account_status',
                    size: 2,
                    type: 'string',
                    width: '5%'
                },
                {
                    displayName: 'Banned',
                    key: 'banned',
                    size: 2,
                    type: 'string'
                },
            ],
            [USER_LTI]: [
                {
                    displayName: 'ID',
                    key:'id',
                    size: 1,
                    type: 'int',
                    width: '5%'
                },
                {
                    displayName: 'First Name',
                    key:'first_name',
                    size: 2,
                    type: 'string',
                    width: '10%'
                },
                {
                    displayName: 'Last Name',
                    key:'last_name',
                    size: 2,
                    type: 'string',
                    width: '10%'
                },
                {
                    displayName: 'Email',
                    key: 'third_party_email',
                    size: 3,
                    type: 'string',
                    width: '25%'
                },
                {
                    displayName: '3P ID',
                    key: 'third_party_id',
                    size: 3,
                    type: 'string',
                    width: '25%'
                },
                {
                    displayName: 'Created Date',
                    key:'created_at',
                    size: 3,
                    type: 'date',
                    width: '12.5%'
                },
                {
                    displayName: 'Last Active',
                    key:'active_at',
                    size: 3,
                    type: 'date',
                    width: '12.5%'
                },
                {
                    displayName: 'Banned',
                    key: 'banned',
                    size: 2,
                    type: 'string'
                },
            ],
        };

        return (
            <div>
                <div className="margin-bottom-lg">
                    <label className="label-form">
                        Filter:
                    </label>
                    <a
                        href="#"
                        className={this.state.viewUserType === USER_AUTHORS ? "sort-link link-selected" : "sort-link"}
                        onClick={this.changeUserType.bind(this, USER_AUTHORS)}
                    >
                        Authors
                    </a>
                    <a
                        href="#"
                        className={this.state.viewUserType === USER_LTI ? "sort-link link-selected" : "sort-link"}
                        onClick={this.changeUserType.bind(this, USER_LTI)}
                    >
                        LTI Users
                    </a>
                </div>
                <PaginationControls
                    id="admin-users-pagination"
                    className="margin-bottom-lg"
                    currentPage={currentPage}
                    numPages={numPages}
                    filterPages={filterPages}
                    totalRecords={totalRecords}
                    searchTerm={searchTerm}
                    requestPage={requestPage}
                    filter={this.state.filter}
                    filterApplied={this.state.filterApplied}
                    onFilterChange={this.onFilterChange}
                    doApplyFilter={this.doApplyFilter}
                />
                <SortableTableClassic
                    key="t-user"
                    title="Users"
                    hideFilter
                    onRowClick={this.onUserClick}
                    onSortChange={this.onSortChange}
                    rows={users}
                    selectedRowKey={!!this.state.selectedUser ? this.state.selectedUser.id : null}
                    dateFormat="YYYY-MM-DD HH:mm:ss"
                    columns={columnsForUserType[this.state.viewUserType]}
                    displayColumnCallbacksId={{
                        banned:(index) => {
                            const u = find(users, { id: index });
                            const currentBan = find(u.ban_history, { active: true });
                            return currentBan ?
                                <span className="ban-banner">{'BANNED'}</span>
                                :
                                '';
                        }
                    }}
                />
                {this.state.selectedUser &&
                    <AdminUserInfoBlock
                        user={this.state.selectedUser}
                        channelRoles={this.state.selectedUserChannelRoles}
                        onDeleteUser={this.toggleDeleteUserModal.bind(this, true, this.state.selectedUser.id)}
                    />
                }

                {this.state.deleteUserModalVisible &&
                    <ConfirmModal
                        show
                        modalTitle="Delete User"
                        text="Are you sure you want to delete this user? All information related to this user will be permanently deleted."
                        buttonText="delete"
                        closeHandler={this.toggleDeleteUserModal.bind(this, false)}
                        confirmHandler={this.onDeleteUser}
                    />
                }
            </div>
        );
    }
}

AdminUsersView.propTypes = propTypes;
AdminUsersView.defaultProps = defaultProps;

export default AdminUsersView;